var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Line 4"),React.createElement("g",{"id":"Why-it-Works-Page","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Science-Page-SMALL","transform":"translate(-189.000000, -1401.000000)","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("g",{"id":"Section-2:-where-you-focus--Copy","transform":"translate(-1.000000, 1100.921348)"},React.createElement("g",{"id":"Hexagons","transform":"translate(102.000000, 270.911590)"},React.createElement("path",{"id":"Line-4","d":"M127.349871,29.5 L141.349871,36.5 L127.349871,43.5 L127.349,37.5 L88.3209753,37.5 L88.3209753,35.5 L127.349,35.5 L127.349871,29.5 Z"})))))]);
}

RightArrow.defaultProps = {"width":"54px","height":"60px","viewBox":"0 0 54 60","version":"1.1"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
